import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "col",
  style: {"width":"100%"}
}
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "voucher-title-wrapper" }
const _hoisted_4 = { class: "voucher-title" }
const _hoisted_5 = ["src"]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_7 = { class: "pax-name" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_9 = { class: "voucher-use-time" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_11 = ["innerHTML"]
const _hoisted_12 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_13 = ["innerHTML"]
const _hoisted_14 = { class: "mt-1" }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = ["src"]
const _hoisted_17 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_19 = {
  style: {"font-size":"15px"},
  class: "d-flex align-center justify-content-center"
}
const _hoisted_20 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_21 = {
  style: {"font-size":"15px"},
  class: "d-flex align-center justify-content-center"
}
const _hoisted_22 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_23 = {
  style: {"font-size":"15px"},
  class: "d-flex align-center justify-content-center"
}
const _hoisted_24 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_25 = {
  style: {"font-size":"15px"},
  class: "d-flex align-center justify-content-center"
}
const _hoisted_26 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_27 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_28 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_29 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_30 = { key: 1 }
const _hoisted_31 = { class: "border-wrap" }
const _hoisted_32 = { class: "title" }
const _hoisted_33 = {
  key: 0,
  class: "title"
}
const _hoisted_34 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_35 = { key: 1 }
const _hoisted_36 = { class: "border-wrap mta4-3" }
const _hoisted_37 = { class: "mta4-3" }
const _hoisted_38 = { key: 0 }
const _hoisted_39 = { class: "mta4-3" }
const _hoisted_40 = { key: 1 }
const _hoisted_41 = { class: "mta4-3" }
const _hoisted_42 = { key: 2 }
const _hoisted_43 = { class: "mta4-3" }
const _hoisted_44 = { key: 3 }
const _hoisted_45 = { class: "mta4-3" }
const _hoisted_46 = { key: 4 }
const _hoisted_47 = ["innerHTML"]
const _hoisted_48 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_col = _resolveComponent("el-col")!

  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.mcData, (data, index) => {
    return (_openBlock(), _createElementBlock("div", {
      key: index,
      class: "pagebreak"
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data, (voucher, inx) => {
        return (_openBlock(), _createElementBlock("div", {
          key: inx,
          style: {"margin-bottom":"20px"}
        }, [
          _createVNode(_component_el_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_el_col, { span: 24 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_row, null, {
                    default: _withCtx(() => [
                      (_ctx.getLinkImgVoucher(_ctx.mcLanguage[index], 'linkLogo', _ctx.showSecondLanguage))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                            _createElementVNode("div", {
                              class: "voucher-logo",
                              style: _normalizeStyle(
                  'float:' +
                  ((_ctx.mcLanguage[index].paxLang.posLogo ?? _ctx.mcLanguage[index].enLang.posLogo) == 'fleft' ? 'left' : 'right')
                )
                            }, [
                              _createElementVNode("img", {
                                src: _ctx.getLinkImgVoucher(_ctx.mcLanguage[index], 'linkLogo', _ctx.showSecondLanguage),
                                width: "150"
                              }, null, 8, _hoisted_2)
                            ], 4)
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 2
                  }, 1024),
                  _createVNode(_component_el_row, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_col, { span: 12 }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_3, [
                            _createElementVNode("div", _hoisted_4, [
                              (_ctx.getLinkImgVoucher(_ctx.mcLanguage[index], 'linkIcon', _ctx.showSecondLanguage))
                                ? (_openBlock(), _createElementBlock("img", {
                                    key: 0,
                                    alt: "",
                                    src: _ctx.getLinkImgVoucher(_ctx.mcLanguage[index], 'linkIcon', _ctx.showSecondLanguage),
                                    width: "30"
                                  }, null, 8, _hoisted_5))
                                : _createCommentVNode("", true),
                              _createElementVNode("strong", null, [
                                _createElementVNode("span", null, _toDisplayString(_ctx.mcLanguage[index].enLang.row1), 1),
                                (_ctx.showSecondLanguage)
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                      _hoisted_6,
                                      _createElementVNode("span", null, _toDisplayString(_ctx.mcLanguage[index].paxLang.row1), 1)
                                    ], 64))
                                  : _createCommentVNode("", true)
                              ])
                            ])
                          ])
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1024),
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("span", null, _toDisplayString(_ctx.mcLanguage[index].enLang.row2), 1),
                    (_ctx.showSecondLanguage)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _hoisted_8,
                          _createElementVNode("span", null, _toDisplayString(_ctx.mcLanguage[index].paxLang.row2), 1)
                        ], 64))
                      : _createCommentVNode("", true)
                  ]),
                  _createVNode(_component_el_row, {
                    class: "mta4-3",
                    gutter: 25
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_col, { span: 12 }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_9, [
                            _createElementVNode("strong", null, _toDisplayString(_ctx.mcLanguage[index].enLang.row3), 1),
                            (_ctx.showSecondLanguage)
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                  _hoisted_10,
                                  _createElementVNode("strong", null, _toDisplayString(_ctx.mcLanguage[index].paxLang.row3), 1)
                                ], 64))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("p", {
                            class: "mt-1",
                            innerHTML: 
                  _ctx.languageReplace(_ctx.mcLanguage[index].enLang.row4, {
                    ['<currency>']: voucher.currency,
                    ['<amount>']: voucher.valamount
                  })
                
                          }, null, 8, _hoisted_11),
                          _createElementVNode("p", null, _toDisplayString(_ctx.mcLanguage[index].enLang.row5), 1),
                          _createElementVNode("p", null, _toDisplayString(_ctx.mcLanguage[index].enLang.row6), 1),
                          (_ctx.showSecondLanguage)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _hoisted_12,
                                _createElementVNode("p", {
                                  class: "mt-1",
                                  innerHTML: 
                    _ctx.languageReplace(_ctx.mcLanguage[index].paxLang.row4, {
                      ['<currency>']: voucher.currency,
                      ['<amount>']: voucher.valamount
                    })
                  
                                }, null, 8, _hoisted_13),
                                _createElementVNode("p", null, _toDisplayString(_ctx.mcLanguage[index].paxLang.row5), 1),
                                _createElementVNode("p", null, _toDisplayString(_ctx.mcLanguage[index].paxLang.row6), 1)
                              ], 64))
                            : _createCommentVNode("", true)
                        ]),
                        _: 2
                      }, 1024),
                      _createVNode(_component_el_col, { span: 12 }, {
                        default: _withCtx(() => [
                          _createElementVNode("strong", null, _toDisplayString(voucher.currency) + " " + _toDisplayString(voucher.valamount), 1),
                          _createElementVNode("p", _hoisted_14, _toDisplayString(_ctx.mcLanguage[index].enLang.row13), 1),
                          (_ctx.showSecondLanguage)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_15, _toDisplayString(_ctx.mcLanguage[index].paxLang.row13), 1))
                            : _createCommentVNode("", true),
                          _createElementVNode("img", {
                            class: "qrcode",
                            src: 'data:image/png;base64,' + voucher.qrCodeDetail.qr_code
                          }, null, 8, _hoisted_16),
                          _createElementVNode("span", null, _toDisplayString(_ctx.mcLanguage[index].enLang.row18) + _toDisplayString(voucher.qrCodeDetail.link_mobile), 1),
                          (_ctx.showSecondLanguage)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                _hoisted_17,
                                _createElementVNode("span", null, _toDisplayString(_ctx.mcLanguage[index].paxLang.row18) + _toDisplayString(voucher.qrCodeDetail.link_mobile), 1)
                              ], 64))
                            : _createCommentVNode("", true)
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1024),
                  _createVNode(_component_el_row, {
                    class: "mta4-3 mc",
                    gutter: 25
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_col, { span: 12 }, {
                        default: _withCtx(() => [
                          _createElementVNode("strong", null, _toDisplayString(_ctx.mcLanguage[index].enLang.row7), 1),
                          (_ctx.showSecondLanguage)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _hoisted_18,
                                _createElementVNode("strong", null, _toDisplayString(_ctx.mcLanguage[index].paxLang.row7), 1)
                              ], 64))
                            : _createCommentVNode("", true),
                          _createVNode(_component_el_row, { class: "mta4-3" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_col, { span: 5 }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_19, [
                                    _createElementVNode("i", {
                                      class: _normalizeClass(["icon-border", 
                        _ctx.mcLanguage[index].paxLang.icon_scan
                          ? _ctx.mcLanguage[index].paxLang.icon_scan
                          : _ctx.mcLanguage[index].enLang.icon_scan
                      ]),
                                      style: _normalizeStyle(_ctx.iconStyle)
                                    }, null, 6),
                                    _createElementVNode("span", {
                                      class: "color-text-icon",
                                      style: _normalizeStyle(_ctx.colorStyle)
                                    }, _toDisplayString(_ctx.mcLanguage[index].paxLang?.row9 ?? _ctx.mcLanguage[index].enLang.row9), 5)
                                  ])
                                ]),
                                _: 2
                              }, 1024),
                              _createVNode(_component_el_col, { span: 18 }, {
                                default: _withCtx(() => [
                                  _createElementVNode("span", null, _toDisplayString(_ctx.mcLanguage[index].enLang.row13), 1),
                                  (_ctx.showSecondLanguage)
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                        _hoisted_20,
                                        _createElementVNode("span", null, _toDisplayString(_ctx.mcLanguage[index].paxLang.row13), 1)
                                      ], 64))
                                    : _createCommentVNode("", true)
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_component_el_row, { class: "mta4-3" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_col, { span: 5 }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_21, [
                                    _createElementVNode("i", {
                                      class: _normalizeClass(["icon-border", 
                        _ctx.mcLanguage[index].paxLang.icon_bank
                          ? _ctx.mcLanguage[index].paxLang.icon_bank
                          : _ctx.mcLanguage[index].enLang.icon_bank
                      ]),
                                      style: _normalizeStyle(_ctx.iconStyle)
                                    }, null, 6),
                                    _createElementVNode("span", {
                                      class: "color-text-icon",
                                      style: _normalizeStyle(_ctx.colorStyle)
                                    }, _toDisplayString(_ctx.mcLanguage[index].paxLang?.row10 ?? _ctx.mcLanguage[index].enLang.row10), 5)
                                  ])
                                ]),
                                _: 2
                              }, 1024),
                              _createVNode(_component_el_col, { span: 18 }, {
                                default: _withCtx(() => [
                                  _createElementVNode("span", null, _toDisplayString(_ctx.mcLanguage[index].enLang.row14), 1),
                                  (_ctx.showSecondLanguage)
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                        _hoisted_22,
                                        _createElementVNode("span", null, _toDisplayString(_ctx.mcLanguage[index].paxLang.row14), 1)
                                      ], 64))
                                    : _createCommentVNode("", true)
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_component_el_row, { class: "mta4-3" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_col, { span: 5 }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_23, [
                                    _createElementVNode("i", {
                                      class: _normalizeClass(["icon-border", 
                        _ctx.mcLanguage[index].paxLang.icon_wire
                          ? _ctx.mcLanguage[index].paxLang.icon_wire
                          : _ctx.mcLanguage[index].enLang.icon_wire
                      ]),
                                      style: _normalizeStyle(_ctx.iconStyle)
                                    }, null, 6),
                                    _createElementVNode("span", {
                                      class: "color-text-icon",
                                      style: _normalizeStyle(_ctx.colorStyle)
                                    }, _toDisplayString(_ctx.mcLanguage[index].paxLang?.row11 ?? _ctx.mcLanguage[index].enLang.row11), 5)
                                  ])
                                ]),
                                _: 2
                              }, 1024),
                              _createVNode(_component_el_col, { span: 18 }, {
                                default: _withCtx(() => [
                                  _createElementVNode("span", null, _toDisplayString(_ctx.mcLanguage[index].enLang.row15), 1),
                                  (_ctx.showSecondLanguage)
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                        _hoisted_24,
                                        _createElementVNode("span", null, _toDisplayString(_ctx.mcLanguage[index].paxLang.row15), 1)
                                      ], 64))
                                    : _createCommentVNode("", true)
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_component_el_row, { class: "mta4-3" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_col, { span: 5 }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_25, [
                                    _createElementVNode("i", {
                                      class: _normalizeClass(["icon-border", 
                        _ctx.mcLanguage[index].paxLang.icon_receive
                          ? _ctx.mcLanguage[index].paxLang.icon_receive
                          : _ctx.mcLanguage[index].enLang.icon_receive
                      ]),
                                      style: _normalizeStyle(_ctx.iconStyle)
                                    }, null, 6),
                                    _createElementVNode("span", {
                                      class: "color-text-icon",
                                      style: _normalizeStyle(_ctx.colorStyle)
                                    }, _toDisplayString(_ctx.mcLanguage[index].paxLang?.row12 ?? _ctx.mcLanguage[index].enLang.row12), 5)
                                  ])
                                ]),
                                _: 2
                              }, 1024),
                              _createVNode(_component_el_col, { span: 18 }, {
                                default: _withCtx(() => [
                                  _createElementVNode("span", null, _toDisplayString(_ctx.mcLanguage[index].enLang.row16), 1),
                                  (_ctx.showSecondLanguage)
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                        _hoisted_26,
                                        _createElementVNode("span", null, _toDisplayString(_ctx.mcLanguage[index].paxLang.row16), 1)
                                      ], 64))
                                    : _createCommentVNode("", true)
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1024),
                      _createVNode(_component_el_col, { span: 12 }, {
                        default: _withCtx(() => [
                          _createElementVNode("strong", null, _toDisplayString(_ctx.mcLanguage[index].enLang.row19), 1),
                          (_ctx.showSecondLanguage)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _hoisted_27,
                                _createElementVNode("strong", null, _toDisplayString(_ctx.mcLanguage[index].paxLang.row19), 1)
                              ], 64))
                            : _createCommentVNode("", true),
                          _hoisted_28,
                          _hoisted_29,
                          _createElementVNode("p", null, _toDisplayString(_ctx.mcLanguage[index].enLang.row20), 1),
                          (_ctx.showSecondLanguage)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_30, _toDisplayString(_ctx.mcLanguage[index].paxLang.row20), 1))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", _hoisted_31, [
                            _createElementVNode("p", _hoisted_32, _toDisplayString(_ctx.mcLanguage[index].enLang.row21) + ":", 1),
                            (_ctx.showSecondLanguage)
                              ? (_openBlock(), _createElementBlock("p", _hoisted_33, _toDisplayString(_ctx.mcLanguage[index].paxLang.row21) + ":", 1))
                              : _createCommentVNode("", true),
                            _hoisted_34,
                            _createElementVNode("p", null, _toDisplayString(_ctx.mcLanguage[index].enLang.row22), 1),
                            (_ctx.showSecondLanguage)
                              ? (_openBlock(), _createElementBlock("p", _hoisted_35, _toDisplayString(_ctx.mcLanguage[index].paxLang.row22), 1))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("div", _hoisted_36, [
                            _createElementVNode("p", _hoisted_37, _toDisplayString(_ctx.mcLanguage[index].enLang.row23), 1),
                            (_ctx.showSecondLanguage)
                              ? (_openBlock(), _createElementBlock("p", _hoisted_38, _toDisplayString(_ctx.mcLanguage[index].paxLang.row23), 1))
                              : _createCommentVNode("", true),
                            _createElementVNode("p", _hoisted_39, _toDisplayString(_ctx.mcLanguage[index].enLang.row24), 1),
                            (_ctx.showSecondLanguage)
                              ? (_openBlock(), _createElementBlock("p", _hoisted_40, _toDisplayString(_ctx.mcLanguage[index].paxLang.row24), 1))
                              : _createCommentVNode("", true),
                            _createElementVNode("p", _hoisted_41, _toDisplayString(_ctx.mcLanguage[index].enLang.row25), 1),
                            (_ctx.showSecondLanguage)
                              ? (_openBlock(), _createElementBlock("p", _hoisted_42, _toDisplayString(_ctx.mcLanguage[index].paxLang.row25), 1))
                              : _createCommentVNode("", true),
                            _createElementVNode("p", _hoisted_43, _toDisplayString(_ctx.mcLanguage[index].enLang.row26), 1),
                            (_ctx.showSecondLanguage)
                              ? (_openBlock(), _createElementBlock("p", _hoisted_44, _toDisplayString(_ctx.mcLanguage[index].paxLang.row26), 1))
                              : _createCommentVNode("", true),
                            _createElementVNode("p", _hoisted_45, _toDisplayString(_ctx.mcLanguage[index].enLang.row27), 1),
                            (_ctx.showSecondLanguage)
                              ? (_openBlock(), _createElementBlock("p", _hoisted_46, _toDisplayString(_ctx.mcLanguage[index].paxLang.row27), 1))
                              : _createCommentVNode("", true),
                            _createElementVNode("p", {
                              class: "mta4-3",
                              innerHTML: _ctx.languageReplace(_ctx.mcLanguage[index].enLang.row28, { ['<voucher_code>']: voucher.voucher_code })
                            }, null, 8, _hoisted_47),
                            (_ctx.showSecondLanguage)
                              ? (_openBlock(), _createElementBlock("p", {
                                  key: 5,
                                  innerHTML: _ctx.languageReplace(_ctx.mcLanguage[index].paxLang.row28, { ['<voucher_code>']: voucher.voucher_code })
                                }, null, 8, _hoisted_48))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 2
              }, 1024)
            ]),
            _: 2
          }, 1024)
        ]))
      }), 128))
    ]))
  }), 128))
}